import { network } from 'services/network';

import { QueryParams } from 'api/mutations/login.mutation';

export const validateLogin = (params: QueryParams) => {
    return network.post('admin/bo/validateLogin', params).then((response) => {
        return response.data;
    });
};
